<template>
  <auth-shell
    :title="$t('auth.otp.title')"
    :subtitle="$t('auth.otp.sub')"
    :back-label="$t('auth.back')"
    icon="fal fa-paper-plane"
    icon-tone="lime"
  >
    <form class="ps-auth-form" novalidate @submit.prevent="submitForm(otp)">
      <brutal-otp-input ref="otpInput" @complete="handleOnComplete" />

      <button
        type="submit"
        class="ps-btn ps-btn--brand ps-btn--block ps-auth-submit"
        :disabled="overlay"
      >
        {{ overlay ? "…" : $t("auth.otp.submit") }}
      </button>
    </form>

    <p class="ps-auth-switch">
      {{ $t("auth.otp.notReceived") }}
      <a
        href="#"
        class="ps-auth-switch__link"
        :class="{ 'ps-auth-switch__link--disabled': tSec > 0 }"
        @click.prevent="resend"
      >
        {{ $t("auth.otp.resend") }}
        <span class="ps-auth-switch__timer">({{ tSec }}s)</span>
      </a>
    </p>

    <app-loading :overlay="overlay" />
  </auth-shell>
</template>

<script>
import { toast } from "@/controllers/alert";
import AuthShell from "@/components/auth/AuthShell.vue";
import BrutalOtpInput from "@/components/auth/BrutalOtpInput.vue";

export default {
  name: "VerifyOtpPage",
  layout: "blank",
  components: { AuthShell, BrutalOtpInput },
  data: () => ({
    overlay: false,
    otp: "",
    tSec: 60,
    tick: null,
  }),
  mounted() {
    this.tick = setInterval(() => {
      this.tSec--;
      if (this.tSec <= 0) clearInterval(this.tick);
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.tick);
  },
  methods: {
    handleOnComplete(value) {
      this.otp = value;
      this.submitForm(value);
    },

    async submitForm(otp) {
      try {
        const form = {
          email: this.$route.query.email,
          otp: otp,
        };
        this.overlay = true;
        const { data } = await this.$http.post("verify_email", form);
        if (data.status) {
          await toast(this, data.message);
          this.overlay = false;
          this.$router.push({
            path: "/new-password",
            query: {
              email: form.email,
              token: data.data,
              otp: form.otp,
            },
          });
        }
      } catch (error) {
        this.overlay = false;
        console.log("submitForm ===> ", error);
      }
    },

    async resend() {
      if (this.tSec > 0) return;
      this.tSec = 60;
      try {
        const { data } = await this.$http.post("resend_verify_otp", {
          email: this.$route.query.email,
        });
        if (data.status) await toast(this, data.message);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.ps-auth-form {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ps-auth-submit {
  padding: 1rem;
}

.ps-auth-switch {
  margin: 24px 0 0;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--ps-slate-500);
}

.ps-auth-switch__link {
  color: var(--ps-brand);
  font-weight: 900;
  text-decoration: none;
}
.ps-auth-switch__link--disabled {
  color: var(--ps-slate-400);
  cursor: default;
}
.ps-auth-switch__timer {
  color: var(--ps-slate-400);
}
</style>
